import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.businessIntelligence}cumul/authorization`;

export interface CumulioTokens {
  authKey: string;
  authToken: string;
  filteredDashboardIds: string[];
}

export const getCumulAuthorization = async ({
  sellerId,
}: {
  sellerId?: string;
}): Promise<BackResponse<CumulioTokens> | BackResponseFailure> => {
  try {
    const response = await apiCall<BackResponse<CumulioTokens>>(
      buildUrl(ENDPOINT, {
        sellerId,
      }),
      {
        method: SUPPORTED_METHODS.GET,
      },
    );

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
